import { mountVacancyBanner } from 'src/parts/vacancy_banner.js';
import { getSsrState } from 'src/utils/ssr.js';
import { createVueApp } from 'src/utils/vue.js';

import RatingsPageBody from 'src/components/ratings/RatingsPageBody/RatingsPageBody.vue';

const {
  ratings,
  query,
  order,
  orderOptions,
  tab,
  tabOptions,
  period,
  periodOptions,
  rateHref,
  helpHref,
} = getSsrState();

const app = createVueApp({
  render(h) {
    return h(RatingsPageBody, {
      props: {
        ratings,
        query,
        order,
        orderOptions,
        tab,
        tabOptions,
        period,
        periodOptions,
        rateHref,
        helpHref,
      },
    });
  },
});

app.$mount('[data-list-body]');
mountVacancyBanner(getSsrState());